import Vue from 'vue';
import VueProgressBar from 'vue-progressbar';
import moment from 'moment';
import App from './App.vue';
import router from './router/index';
import store from './store/index';
import vSelect from 'vue-select'

import './script';
import 'popper.js';
import 'bootstrap';
import './registerServiceWorker';

import MlSidebar from './components/MlSidebar.vue';
import Alert from './components/elements/alert/Alert.vue';

import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import 'vue-select/dist/vue-select.css';

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import VueContentLoading from 'vue-content-loading'

import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import 'leaflet-geosearch/dist/geosearch.css'; 
import { Icon } from "leaflet";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-marker", LMarker);

Vue.component('vcl', VueContentLoading);
Vue.component('ml-sidebar', MlSidebar);
Vue.component('ml-alert', Alert);
Vue.component('datetime', Datetime);
Vue.component('v-select', vSelect)

Vue.use(VueProgressBar, { color: '#c26ad6', failedColor: '#fc595e', thickness: '5px' });
Vue.use(Datetime)

Vue.config.productionTip = false;
moment.locale('id');

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app');

Vue.filter('toTanggal', function(value) {
	var date = moment(value).format('DD MMMM YYYY')
	if (date == 'Invalid date') {
		return '-'
	} else {
		return date
	}
});
Vue.filter('tanggal', function(value) {
	var date = moment(value).format('dddd, DD MMMM YYYY')
	if (date == 'Invalid date' || !value) {
		return '-'
	} else {
		return date
	}
});
Vue.filter('tanggaljam', function(value) {
	var date = moment(value).format('DD MMMM YYYY HH:mm:ss')
	if (date == 'Invalid date' || !value) {
		return '-'
	} else {
		return date
	}
});
Vue.filter('tanggalnumber', function(value) {
	var date = moment(value).format('DD/MM/YYYY')
	if (date == 'Invalid date' || !value) {
		return '-'
	} else {
		return date
	}
});
Vue.filter('toRupiah', function(value) {
	var formatter = new Intl.NumberFormat('id', {
		minimumFractionDigits: 0
	});

	return 'Rp ' + formatter.format(parseInt(value));
});

Vue.filter('toNumber', function(value) {
	var formatter = new Intl.NumberFormat('id', {
		minimumFractionDigits: 0
	});

	return formatter.format(parseInt(value));
});

Vue.filter('toColorProduct', (value) => {
	let qty = parseInt(value)
	if (qty == 0) {
		return 'color-red'
	} else if (qty > 25) {
		return 'color-green'
	} else if (qty <= 25) {
		return 'color-yellow'
	}
});

Vue.filter('convertStockType', (value) => {
	if (value == 'in') {
		return 'Masuk';
	} else {
		return 'Keluar';
	}
});

Vue.directive('uppercase', {
	twoWay: true,
	bind: function(el) {
		addEventListener('input', () => {
			el.value = el.value.toUpperCase()
		})
	},
})

Vue.directive('rupiahFormat', {
	twoWay: true,
	bind: function(el) {
		addEventListener('input', () => {
			var formatter = new Intl.NumberFormat('id', {
				minimumFractionDigits: 0
			});
			var value = 0
			if (el.value) {
				value = el.value.replace(/\D/g, "");
			}
			el.value = formatter.format(parseInt(value));
		})
	},
})

Vue.mixin({
	methods: {
		onlyNumber($event) {
			let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

			if ((keyCode < 48 || keyCode > 57) && keyCode !== 8) {
				$event.preventDefault();
			}
		},
		queryString(value) {
			let parameterObject = {}
			let parameter = '{'

			if (value.params) {
				value.params.forEach((value, index) => {
					for (const [key, val] of Object.entries(value)) {
						parameter += `"filter[${index}][${key}]":"${val}",`
					}
				})
			}
			parameter += `"limit": "${value.limit}", "page": "${value.page}", "sort": "${value.sort}", "dir": "${value.dir}"`
			parameter += '}'
			parameterObject = JSON.parse(parameter)
			return parameterObject
		},
	}
})

Vue.filter('statusSerial', (value) => {
	if (value == '0') {
		return 'Tersedia';
	} else if (value == '1') {
		return 'Terjual';
	} else {
		return 'Kadaluarsa';
	}
});

Vue.filter('toStatusPO', (value) => {
	let status = {
		created: 'Dibuat',
		on_delivery: 'Sedang Dikirim',
		delivered: 'Sudah Diterima',
		scanned: 'Sedang Diproses',
		completed: 'Selesai'
	}
	return status[value];
});

Vue.filter('two_digits', (value) => {
	if (value < 0) {
		return '00';
	}
	if (value.toString().length <= 1) {
		return `0${value}`;
	}
	return value;
});

Vue.filter('hariTanggalJam', function(value) {
	var date = moment(value).format('dddd, DD MMMM YYYY HH:mm:ss')
	if(date == 'Invalid date'){
		return '-'
	} else {
		return date
	}
});